import React from "react";
import { Button, Divider } from "@src/components/atoms";
import { SignolUtils } from "@src/utils";
import { SectionEditor } from "./SectionEditor";

const normalizeGraphData = (data) =>
  Array.isArray(data) ? data : SignolUtils.normalizeBehiveKey(data);

const getDuplicateGraphsInLayout = (layout) => {
  let currentlyUsedGraphs = [];
  for (let s = 0; s < layout.sections.length; s++) {
    for (let r = 0; r < layout.sections[s].rows.length; r++) {
      for (let c = 0; c < layout.sections[s].rows[r].cols.length; c++) {
        currentlyUsedGraphs.push(
          normalizeGraphData(layout.sections[s].rows[r].cols[c].data),
        );
      }
    }
  }
  return currentlyUsedGraphs.filter(
    (item, index) => currentlyUsedGraphs.indexOf(item) !== index,
  );
};

export const LayoutEditor = (props) => {
  const {
    dataOptions,
    behaviourOptions,
    grid,
    setGrid,
    saveLayout,
    deleteLayout,
  } = props;
  // const [grid, setGrid] = useState(initialGrid);
  const duplicateGraphs = getDuplicateGraphsInLayout(grid);

  const setSectionTitle = (newValue, sectionIndex) => {
    let sections = grid.sections;
    sections[sectionIndex].title = newValue;
    setGrid({ sections });
  };

  const removeSection = (index) => {
    let sections = grid.sections;
    sections.splice(index, 1);
    setGrid({ sections });
  };

  const addSection = (index) => {
    let sections = grid.sections;
    const newSection = { rows: [] };
    if (index === undefined) {
      sections.push(newSection);
    } else {
      sections.splice(index, 0, newSection);
    }
    setGrid({ sections });
  };

  const addRow = (index) => {
    let sections = grid.sections;
    sections[index].rows.push({
      cols: [],
    });
    setGrid({ sections });
  };

  const removeRow = (sectionIndex, rowIndex) => {
    let sections = grid.sections;
    sections[sectionIndex].rows.splice(rowIndex, 1);
    setGrid({ sections });
  };

  const removeCol = (sectionIndex, rowIndex, colIndex) => {
    let sections = grid.sections;
    sections[sectionIndex].rows[rowIndex].cols.splice(colIndex, 1);
    setGrid({ sections });
  };

  const addCol = (sectionIndex, rowIndex) => {
    let sections = grid.sections;
    sections[sectionIndex].rows[rowIndex].cols.push({
      behaviourCode: behaviourOptions[0].value,
      data: undefined,
      width: 1,
      align: "center",
      contentType: "graph",
    });
    setGrid({ sections });
  };

  const changeColWidth = (sectionIndex, rowIndex, colIndex, newValue) => {
    let sections = grid.sections;
    sections[sectionIndex].rows[rowIndex].cols[colIndex].width = newValue;
    setGrid({ sections });
  };

  const changeColAlign = (sectionIndex, rowIndex, colIndex, newValue) => {
    let sections = grid.sections;
    sections[sectionIndex].rows[rowIndex].cols[colIndex].align = newValue;
    setGrid({ sections });
  };

  const changeColBehaviour = (sectionIndex, rowIndex, colIndex, newValue) => {
    let sections = grid.sections;
    sections[sectionIndex].rows[rowIndex].cols[colIndex].behaviourCode =
      newValue;
    setGrid({ sections });
  };

  const changeColGraph = (sectionIndex, rowIndex, colIndex, newValue) => {
    let sections = grid.sections;
    sections[sectionIndex].rows[rowIndex].cols[colIndex].data = newValue;
    setGrid({ sections });
  };

  const changeContentType = (sectionIndex, rowIndex, colIndex, newValue) => {
    let sections = grid.sections;
    sections[sectionIndex].rows[rowIndex].cols[colIndex].contentType = newValue;
    setGrid({ sections });
  };

  const handleSaveLayout = () => {
    saveLayout(grid);
  };

  const handleDeleteLayout = () => {
    deleteLayout();
    setGrid({ sections: [] });
  };

  let dataErrors = false;
  for (let s = 0; s < grid.sections.length; s++) {
    for (let r = 0; r < grid.sections[s].rows.length; r++) {
      for (let c = 0; c < grid.sections[s].rows[r].cols.length; c++) {
        if (!grid.sections[s].rows[r].cols[c].data) {
          dataErrors = true;
        }
      }
    }
  }

  console.log(dataErrors);

  return (
    <section className="m-6">
      <div>
        {grid.sections.length > 0 && (
          <>
            <Button onClick={() => addSection(0)}>Add Section</Button>
            <Divider />
          </>
        )}
        {grid.sections.map((section, idx) => {
          return (
            <SectionEditor
              title={section.title}
              key={idx}
              index={idx}
              addRow={addRow}
              addSection={addSection}
              removeSection={removeSection}
              rows={section.rows}
              addCol={addCol}
              removeCol={removeCol}
              removeRow={removeRow}
              changeColWidth={changeColWidth}
              changeColAlign={changeColAlign}
              dataOptions={dataOptions}
              behaviourOptions={behaviourOptions}
              changeColBehaviour={changeColBehaviour}
              changeColGraph={changeColGraph}
              changeContentType={changeContentType}
              duplicateGraphs={duplicateGraphs}
              setSectionTitle={setSectionTitle}
            />
          );
        })}
      </div>
      <Button onClick={() => addSection()}>Add Section</Button>
      <Button
        disabled={grid.sections.length <= 0 || dataErrors}
        onClick={handleSaveLayout}
      >
        Save Layout
      </Button>
      <Button
        disabled={grid.sections.length === 0}
        color="red"
        onClick={handleDeleteLayout}
      >
        Delete Layout
      </Button>
    </section>
  );
};
